import { render, staticRenderFns } from "./SchoolBreakdownTable.vue?vue&type=template&id=3ec934a6"
import script from "./SchoolBreakdownTable.vue?vue&type=script&lang=js"
export * from "./SchoolBreakdownTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports